import { Modal as ModalModule, UI, Utils } from 'common';
import { Accordion, AccordionTab } from 'primereact/accordion';
import React from 'react';
import ListFilter from './ListFilter.component';

const { ModalContext, Modal } = ModalModule;
const { WrappedButton, WrappedButtonType } = UI;
const { Session, UserRole } = Utils;

const roles = ['Corporate Admin', 'Region Admin', 'Location Admin', 'User'].map(
	role => ({
		Name: role,
		value: role,
	})
);
const timestamps = new Date().getTime();

class UserFiltersModal extends React.Component {
	constructor(props) {
		super(props);
		const { data } = props;
		const userRole = Session.getUserRole();
		this.listData = [
			{
				name: 'Roles',
				data: roles,
				hidden: !(roles.length > 0),
			},
			{
				name: 'Regions',
				data: data.regions,
				hidden: !(userRole === UserRole.CorpAdmin && data.regions.length > 0),
			},
			{
				name: 'Locations',
				data: data.locations,
				hidden: !(data.locations.length > 0),
			},
		];
		/**
		 * get Name property of all Data
		 */
		this.parsedData = {
			Roles: roles.map(info => info.Name),
			Locations: data.locations.map(info => info.Name),
			Regions: data.regions.map(info => info.Name),
		};

		const unfiltered =
			data.filters.Roles.length === 0 &&
			data.filters.Locations.length === 0 &&
			data.filters.Regions.length === 0;

		this.state = {
			/**
			 * Only need filterData for top-level state. We need it to control children
			 * based on props data.filters, we initialize filterData state
			 * if !unfiltered open modal => set =  props.data.filters[Name]
			 * else set = all available data
			 */
			filterData: {
				Roles: !unfiltered ? data.filters.Roles : this.parsedData.Roles,
				Locations: !unfiltered
					? data.filters.Locations
					: this.parsedData.Locations,
				Regions: !unfiltered ? data.filters.Regions : this.parsedData.Regions,
			},
			/**
			 * This state keeps track the event Reset.
			 * It will be passed to children comp to reset value and re-set = false after finished.
			 */
			renderTimestamp: timestamps,
		};
	}

	/**
	 * Based on the value of checked
	 * if true add value of checkbox to correct fieldName
	 * else remove this value.
	 */
	handleSelectCheckbox = e => {
		const { filterData } = this.state;
		const { name, checked, value } = e.target;
		let filterSelected = [...filterData[name]];
		filterSelected = checked
			? [...filterSelected, value]
			: filterSelected.filter(selected => selected !== value);

		this.setState({
			filterData: {
				...filterData,
				[name]: filterSelected,
			},
		});
	};

	handleResetFilter = () => {
		const newTimestamp = new Date().getTime();

		this.setState({
			renderTimestamp: newTimestamp,
			filterData: this.parsedData,
		});
	};

	handleSaveFilter = () => {
		const { data, modalId } = this.props;
		const { filterData } = this.state;
		const { closeModal } = this.context;
		data.handleFilter(filterData, () => {
			closeModal(modalId);
		});
	};

	setFilterData = value => {
		const { filterData } = this.state;

		this.setState({
			filterData: {
				...filterData,
				...value,
			},
		});
	};

	renderFiltersList = () => {
		const { filterData, renderTimestamp } = this.state;

		return this.listData.reduce((accumulator, tabInfo) => {
			if (!tabInfo.hidden) {
				accumulator.push(
					<AccordionTab key={tabInfo.name} header={tabInfo.name}>
						<ListFilter
							tabInfo={tabInfo}
							filterData={filterData[tabInfo.name]}
							handleSelectCheckbox={this.handleSelectCheckbox}
							setFilterData={this.setFilterData}
							key={renderTimestamp}
						/>
					</AccordionTab>
				);
			}
			return accumulator;
		}, []);
	};

	render() {
		const { modalId } = this.props;
		const { filterData } = this.state;
		const clean =
			filterData.Roles.length === 0 &&
			filterData.Regions.length === 0 &&
			filterData.Locations.length === 0;

		return (
			<Modal
				modalId={modalId}
				header="Filters"
				hideFooter
				className="account-users account-users-filters-modal"
				size="small"
			>
				<div className="p-grid">
					<div className="p-col-12 filters-body">
						<Accordion activeIndex={0}>{this.renderFiltersList()}</Accordion>
					</div>
					<div className="p-col-12">
						<WrappedButton
							buttonType={WrappedButtonType.Primary}
							onClick={this.handleSaveFilter}
							dataqa="filters-modal-save"
							label="Save"
							disabled={clean}
						/>
						<WrappedButton
							buttonType={WrappedButtonType.Secondary}
							onClick={this.handleResetFilter}
							dataqa="filters-modal-reset"
							label="Reset Filters"
						/>
					</div>
				</div>
			</Modal>
		);
	}
}

UserFiltersModal.contextType = ModalContext;

export default UserFiltersModal;
